import { render, staticRenderFns } from "./StaffFeed.vue?vue&type=template&id=17c1465e&scoped=true"
import script from "./StaffFeed.vue?vue&type=script&lang=js"
export * from "./StaffFeed.vue?vue&type=script&lang=js"
import style0 from "./StaffFeed.vue?vue&type=style&index=0&id=17c1465e&prod&scoped=true&lang=css"
import style1 from "./StaffFeed.vue?vue&type=style&index=1&id=17c1465e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1465e",
  null
  
)

export default component.exports